import { render, staticRenderFns } from "./SuggestRoute.vue?vue&type=template&id=5c0631d3&"
import script from "./SuggestRoute.vue?vue&type=script&lang=js&"
export * from "./SuggestRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports